import React, {useEffect} from 'react'
import { withStyles } from '@material-ui/core/styles'
import {
  makeStyles,
  useTheme,
  Tooltip,
  Avatar,
  Popover,
  IconButton,
  MenuItem,
  List,
  ListItem,
  ListItemAvatar,
  ListItemIcon,
  ListItemText,
  Badge,
  Paper,
  Divider,
  Typography,
  Fab,
  Checkbox,
} from '@material-ui/core'
import NotificationsIcon from '@material-ui/icons/Notifications'
import TimerIcon from '@material-ui/icons/Timer'
import TrendingUpSharpIcon from '@material-ui/icons/TrendingUp'
import TrendingDownSharpIcon from '@material-ui/icons/TrendingDown'
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle'
import Cookies from 'js-cookie'
import { RiDeleteBin2Fill, RiMailCheckFill } from 'react-icons/ri'
import { BiMessageRoundedError, BiEnvelopeOpen } from 'react-icons/bi'

const useStyles = makeStyles(theme => ({
  listItem: {
    width: 500,
  },
  remove: {
    color: '#757575',
    fontSize: '17px',
    '&:hover': {
      color: '#e85151',
      cursor: 'pointer',
    }
  }
}))

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
    width: 500,
    marginTop: 48,
  },
})(props => (
  <Popover
    elevation={1}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    {...props}
  />
))

const StyledMenuItem = withStyles(theme => ({
  root: {
    '&:focus': {
      '& .MuiListItemIcon-root & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem)

export default function NotificationsMenu() {
  const classes = useStyles()
  const theme = useTheme()
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [overlap] = React.useState('rectangle')
  const [notifications, setNotifications] = React.useState([])
  const [checked, setChecked] = React.useState([])

  // useEffect(() => {
  //   const fetchData = () => {
  //     fetch('https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/demoTrends/alerts', {
  //       headers: {
  //         'token': Cookies.get('token')
  //       }
  //     })
  //     .then(response => response.json())
  //     .then(data => {
  //       if(data) {
  //         setNotifications(data)
  //       } else {
  //         setNotifications([])
  //       }
  //     })
  //   }
  //   fetchData()
  // },[])

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleRemove = (e, key) => {
    const {checked} = e.target

    console.log(checked)
    console.log(key)
  }

  return(
    <div id="notifications">
      <Tooltip title="NOTIFICATIONS">
        <Fab size="small" className="fab" onClick={handleClick}>
          <Badge badgeContent="" variant="dot" overlap={overlap} color="secondary" invisible={notifications.length < 1 ? true : false}>
              <NotificationsIcon className="icon"/>
          </Badge>
        </Fab>
      </Tooltip>
      <Popover
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <List className="notifications-list">
          {/* <Typography>Mark all as read</Typography> */}
          {/* {notifications.length > 0 ?
            notifications.map(({Data, Key}, i) => (
              <div key={i}>
                <ListItem
                  className={classes.listItem}
                >
                  <ListItemAvatar>
                    <Avatar style={{background: 'transparent', border: `1px solid ${Data[0].YOY_Index > 0 ? '#0abf00' : '#e85151'}`}}>
                      {Data[0].YOY_Index > 0 ? <TrendingUpSharpIcon className="included"/> : <TrendingDownSharpIcon className="excluded"/>}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={<Typography variant="caption" className="title">{Data[0].MetricType.toUpperCase()}</Typography>}
                    secondary={
                      <Typography variant="caption" className="detail">
                        <br/>The largest YOY change for this demographic was in the <span style={{color: '#d882ff'}}>{Data[0].MetricValue}
                        </span> group by {Data[0].YOY_Index > 0 ? 'an increase' : 'a decrease'} of <span className={Data[0].YOY_Index > 0 ? "included" : "excluded"}>
                        {(Data[0].YOY_Index * 100).toFixed(2)}%</span>
                      </Typography>
                    }
                    sx={{width: 425}}
                    secondaryTypographyProps={{
                      variant: "caption",
                      style: {
                        whiteSpace: 'normal'
                      }
                    }}
                    style={{marginLeft: "15px"}}
                  />
                  <Divider orientation="vertical" className="notifications-divider" style={{height: "75px"}}/>
                  <Tooltip title="Mark as read">
                    <ListItemIcon className="notifications-read">
                      <Checkbox
                        icon={<RiMailCheckFill className="remove"/>}
                        checkedIcon={<RiMailCheckFill className="remove-filled"/>}
                        disableRipple
                        style={{backgroundColor: "transparent"}}
                        onClick={(e) => handleRemove(e, Key)}
                      />
                    </ListItemIcon>
                  </Tooltip>
                </ListItem>
                <Divider className="notifications-divider" style={{display: `${i == notifications.length - 1 ? 'none' : ''}`}}/>
              </div>
            ))
          :
            <ListItem>
              <Avatar style={{background: 'transparent', color: '#e6e6e6'}}>
                <BiMessageRoundedError />
              </Avatar>
              <ListItemText
                primary={<Typography variant="caption" style={{color: "#e6e6e6"}}>There are no new notifications at this time. Please check again later.</Typography>}
              />
            </ListItem>
          } */}
        </List>
      </Popover>
    </div>
  )
}
